import {LoadableComponent} from '@loadable/component'
import {useSettings, useStyles} from '@wix/tpa-settings/react'
import {LIST_LAYOUT, MOBILE_LIST_LAYOUT_TYPE, MOBILE_WIDGET_LAYOUT} from '@wix/wix-events-commons-statics'
import {useEnvironment, useExperiments, usePanorama} from '@wix/yoshi-flow-editor'
import React from 'react'
import {LoadableSuspenseWithPreviousFallback} from '../../../../../commons/components/loadable-suspense-with-previous-fallback'
import stylesParams from '../../../stylesParams'
import {useWidgetHost, useWidgetState} from '../../hooks/state-provider'
import {getListLayout, isEmptyStateNotificationVisible, isNarrow} from '../../selectors/list-settings'
import {getComponentConfig, isSingleEventWidget} from '../../selectors/settings'
import {
  Calendar,
  Cards,
  CardsMobile,
  CompactMobile,
  EmptyState,
  ListLayout,
  OnImage,
  SideBySide,
  SingleEvent,
} from './chunks'

export const Layout = () => {
  const {isEditor, isMobile: mobile, isSSR} = useEnvironment()
  const {get} = useStyles()

  const componentConfig = useWidgetState(getComponentConfig)

  const listLayout = getListLayout(componentConfig)
  const singleEventWidget = isSingleEventWidget(componentConfig)

  const host = useWidgetHost()
  const narrowLayout = useWidgetState(state => isNarrow(state, host.dimensions))

  const mobileLayout = get(stylesParams.mobileWidgetLayout)
  const mobileListLayoutType = get(stylesParams.mobileListLayoutType)
  const logger = usePanorama()?.logger?.()

  const {get: getSetting} = useSettings()
  const {experiments} = useExperiments()
  const emptyStateVisible = useWidgetState(state => isEmptyStateNotificationVisible(state, getSetting, experiments))

  const getLayout = (): LoadableComponent<any> => {
    if (emptyStateVisible) {
      return EmptyState
    }

    if (singleEventWidget) {
      return SingleEvent
    }

    if (mobile) {
      if (listLayout === LIST_LAYOUT.CALENDAR) {
        return Calendar
      }

      if (mobileLayout === MOBILE_WIDGET_LAYOUT.ON_IMAGE) {
        return OnImage
      } else if (mobileLayout === MOBILE_WIDGET_LAYOUT.GRID) {
        return CardsMobile
      } else {
        return mobileListLayoutType === MOBILE_LIST_LAYOUT_TYPE.FULL ? CardsMobile : CompactMobile
      }
    }

    switch (listLayout) {
      case LIST_LAYOUT.GRID:
      case LIST_LAYOUT.NEW_GRID:
        return Cards
      case LIST_LAYOUT.SIDE_BY_SIDE:
        return SideBySide
      case LIST_LAYOUT.CALENDAR:
        return Calendar
      case LIST_LAYOUT.ON_IMAGE:
        return OnImage
      default:
        if (narrowLayout) {
          if (!isSSR) {
            logger?.debug?.('Narrow layout widget')
          }
          return CardsMobile
        }
        return ListLayout
    }
  }

  const Component = getLayout()

  return isEditor ? <LoadableSuspenseWithPreviousFallback Component={Component} /> : <Component />
}
